module.exports={Remove:"删除"};